var preloadedMediaFiles = {};

function preloadMedia(noTrials) {
    if(!window.enable_media_preload) {
        onPrepareDone('mediaPreload');
        return;
    }

    console.log('starting media preload');

    var mediaFiles = {}, countToPreload = 0, countPreloaded = 0, failedPreload = [];
  
    var preloadMediaContainer = document.createElement("div");
    preloadMediaContainer.id = 'preloadMediaContainer';
    preloadMediaContainer.style.display = 'none';
  
    for (var i = 0; i < noTrials; i++) {
        var audioColumn = window.columnForTrial('audio', i);
        window.listBackgroundAudioOptions[i] = window.parseAudioColumn(audioColumn);
        var fileExtension = window.columnForTrial('stimFormat', i);

        if (fileExtension !== "list") {  
            for (var iMedia = 1; iMedia <= window.stimFieldsMax; iMedia++) {
                let currentStimName = window.getStimForTrialRow(i, iMedia - 1);
                if(currentStimName === "na") {
                    continue;
                }
                var src = locationStim + currentStimName + '?ts=' + startPreloadTime;
                addMediaToPreloadContainer(src, i, iMedia);
            }
        }

        if(audioColumn !== "na" && audioColumn.indexOf('.mp3') > 0) {
            const audioFile = window.listBackgroundAudioOptions[i].filename;
            var src = locationStim + audioFile + '?ts=' + startPreloadTime;
            addMediaToPreloadContainer(src, i, 0, audioColumn=true);
        }

        var currentActualStim = window.columnForTrial('stim_actual', i);
        if(currentActualStim !== "na") {
            currentActualStim = currentActualStim.split(';');
            const stimSplit = currentActualStim[0].split('.');
            const stimFormat = '.' + stimSplit[stimSplit.length-1];
            if(audioFormats.indexOf(stimFormat) >= 0 || videoFormats.indexOf(stimFormat) >= 0) {
                for(var j = 0; j < currentActualStim.length; j++) {
                    const currentStim = currentActualStim[j];
                    var src = locationStim + currentStim + '?ts=' + startPreloadTime;
                    addMediaToPreloadContainer(src, i, j + 1)
                }
            }
        }
    }
  
    document.body.appendChild(preloadMediaContainer);

    function getPreloadMediaId(stimIndex, trialNo) {
      return "prestim" + stimIndex + '_' + trialNo; 
    }

    function addMediaToPreloadContainer(src, trial, index, audioColumn = false) {
        if(!mediaFiles[src]) {
            let media;
            if(isTrialOfType(trial, 'video')) {
                media = document.createElement('video');
            }
            else if(isTrialOfType(trial, 'audio') || audioColumn) {
                media = document.createElement('audio');
            }
            else {
                return;
            }
            countToPreload++;
            media.addEventListener('error', onMediaError);
            media.id = getPreloadMediaId(index, trial);
            media.src = src;
            media.preload = "auto";
            media.addEventListener('canplaythrough', onMediaPreloaded);
            mediaFiles[src] = media;
            preloadMediaContainer.appendChild(media);
        }
        if(!preloadedMediaFiles[trial]) {
            preloadedMediaFiles[trial] = {};
        }

        preloadedMediaFiles[trial][index] = mediaFiles[src];
    }

    function onMediaError() {
        const erroredFilename = this.src.split('/').pop().split('?')[0];
        if(!failedPreload.length) {
            displayText("content", "Failed to preload: <pre id='preloadErrorMessage' style='display:inline'></pre>");
        }
        displayText("preloadErrorMessage", " " + erroredFilename, null, false, false, true)
        QueryLoader.doneLoad();
        failedPreload.push(erroredFilename);
    }

    function onMediaPreloaded() {
      countPreloaded++;
      QueryLoader.imgCallback();
      this.removeEventListener('canplaythrough', onMediaPreloaded);
      this.removeEventListener('error', onMediaError);
      console.info(countPreloaded + " media loaded out of " + countToPreload);

      if(countPreloaded === countToPreload) {
          onPrepareDone('mediaPreload');
      }
    }

    if(countToPreload === 0) {
        onPrepareDone('mediaPreload');
    }
}